
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/configuracio-comunicacions",
      function () {
        return require("private-next-pages/corporatiu/configuracio-comunicacions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/configuracio-comunicacions"])
      });
    }
  